module.exports = __webpack_public_path__ + "img/client-9.76b882fd.png";